<template lang="pug">
  v-file-input.app-file-input(:value="value" :accept="acceptFormats" :rules="rules" :class="{ 'extra-padding': hasWarnings }" show-size prepend-inner-icon="attach_file" prepend-icon="" label="Выберите файл" small-chips outlined @change="handler")
</template>

<script>
const MAX_SIZE = 100000

export default {
  inheritAttrs: true,
  name:'app-file-input',

  props: {
    value: [File],
    formats: {
      type: Array,
      //default:function () { return ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.openxmlformats-officedocument.wordprocessingml.template'] }
      default:function () { return ['.docx','.xlsx'] }
    },
    maxSize: {
       type: Number,
       default: MAX_SIZE
    }
  },

  computed: {
    acceptFormats () {
      return this.formats.join(', ');
    },

    hasWarnings () {
      return this.value && this.value.size > this.maxSize
    },

    rules() {
      let external = this.value && this.value.name ? this.value.name.substring(this.value.name.lastIndexOf(".")) : null
      if (external && this.formats.length > 0 && !this.formats.includes(external))
        return [() => !this.value || 'Выберите документ с расширением('+this.formats+')']
      return [() => !this.value || this.value.size < this.maxSize || 'Размер документа не должен превышать '+this.maxSize+' байт']

    }
  },

  methods: {
    handler (file) {
      this.$emit('input', file)
    }
  },

  data: () => ({
    //rules: [
    //  value => !value || value.size < maxSize || 'Размер документа не должен превышать '+maxSize+' байт',
    //],
  })
}
</script>

<style lang="scss" scoped>
.extra-padding {
  padding-bottom: 16px;
}
</style>

<style>
.app-file-input.v-file-input input[type=file] {
  position: absolute;
  z-index: -1;
}
</style>